import type { WorkShiftGroupStatus } from "@senciamatch/frontend/utils/workShiftGroupStatus";
import { getStatusLabel } from "@senciamatch/frontend/utils/workShiftGroupStatus";

interface StatusChangeModalProps {
  show: boolean;
  currentStatus: WorkShiftGroupStatus;
  onClose: () => void;
  onConfirm: (newStatus: WorkShiftGroupStatus) => void;
}

export const StatusChangeModal = ({ show, currentStatus, onClose, onConfirm }: StatusChangeModalProps) => {
  if (!show) return null;

  const handleStatusChange = (newStatus: WorkShiftGroupStatus) => {
    onConfirm(newStatus);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">ステータス変更</h2>
          <button type="button" onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors">
            <svg
              className="w-5 h-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">現在のステータス:</p>
          <p className="font-medium">{getStatusLabel(currentStatus)}</p>
        </div>

        <div className="space-y-2">
          <p className="text-sm text-gray-600 mb-2">新しいステータスを選択してください:</p>
          <button
            type="button"
            onClick={() => handleStatusChange("matched")}
            className={`w-full p-3 border rounded-md hover:bg-gray-50 text-left ${
              currentStatus === "matched" ? "bg-gray-100 cursor-not-allowed" : ""
            }`}
            disabled={currentStatus === "matched"}
          >
            マッチング済み（未確定）
          </button>
          <button
            type="button"
            onClick={() => handleStatusChange("fixed")}
            className={`w-full p-3 border rounded-md hover:bg-gray-50 text-left ${
              currentStatus === "fixed" ? "bg-gray-100 cursor-not-allowed" : ""
            }`}
            disabled={currentStatus === "fixed"}
          >
            マッチング済み（確定）
          </button>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
};
